export default "__VITE_ASSET__f5b09e85__"